import script from "./AffiliateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AffiliateModal.vue?vue&type=script&setup=true&lang=js"

import "./AffiliateModal.vue?vue&type=style&index=0&id=99deffec&lang=scss"

const __exports__ = script;

export default __exports__